import React, {Component} from 'react';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

class Dropdown extends Component {
  handleChange = (event) => {
    this.props.onChange(event.target.value);
  };

  render() {
    return (
      <FormControl className={this.props.value == null ? 'dropdown no-value' : 'dropdown'} fullWidth={this.props.fullWidth}>
        <InputLabel>{this.props.label}</InputLabel>
        <Select value={this.props.value} onChange={this.handleChange.bind(this)} inputProps={this.props.inputProps || {}}>
          <MenuItem value={null} disabled></MenuItem>
          {this.props.items.map((items, index) => (
            <MenuItem key={index} value={items.value}>{items.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}


export default Dropdown;
